import {
  Badge as UIBadge,
  BadgeText,
  HStack,
  View
} from "@gluestack-ui/themed";
import { BadgeProps, IBadgeType } from "./types";
import { OptionStyleMap } from "./constants";
import { Icon } from "../Icon";

export const Badge = ({ text, type = IBadgeType.success }: BadgeProps) => {
  const { action, icon, color, iconVariant } = OptionStyleMap[type];

  return (
    <HStack gap="$2" alignItems="center" maxWidth="100%">
      <View w="$6" justifyContent="center" alignItems="center" flexShrink={0}>
        <Icon name={icon} size={24} color={color} variant={iconVariant} />
      </View>
      <UIBadge
        py="$1"
        px="$2"
        size="sm"
        variant="outline"
        borderRadius="$sm"
        action={action}
        flexShrink={1}
        maxWidth="100%"
      >
        <BadgeText
          textTransform="none"
          fontSize={"$xs"}
          fontWeight={600}
          flexWrap="wrap"
          numberOfLines={0}
        >
          {text}
        </BadgeText>
      </UIBadge>
    </HStack>
  );
};
